import React from 'react';

// 스켈레톤 애니메이션을 위한 기본 클래스
const skeletonBase = "bg-gray-200 animate-pulse rounded";

// 블로그 카드 스켈레톤 컴포넌트
function BlogCardSkeleton() {
  return (
    <div className="bg-white rounded-xl overflow-hidden max-w-4xl">
      <div className="flex flex-col md:gap-3 md:flex-row">
        {/* 이미지 스켈레톤 */}
        <div className="w-full md:w-56 relative order-1 md:order-2 overflow-hidden p-4 flex items-center">
          <div className="h-52 md:h-44 w-full">
            <div className={`${skeletonBase} w-full h-full rounded-xl`}></div>
          </div>
        </div>
        
        {/* 콘텐츠 스켈레톤 */}
        <div className="flex-1 p-3 md:p-5 order-2 md:order-1">
          {/* 날짜 스켈레톤 */}
          <div className={`${skeletonBase} h-4 w-24 mb-3 md:mb-4 rounded-md`}></div>
          
          {/* 제목 스켈레톤 */}
          <div className="mb-3">
            <div className={`${skeletonBase} h-6 md:h-7 w-full rounded-md mb-2`}></div>
          </div>
          
          {/* 서브타이틀 스켈레톤 */}
          <div className="mb-3 md:mb-5">
            <div className={`${skeletonBase} h-4 w-full mb-1 rounded-md`}></div>
            <div className={`${skeletonBase} h-4 w-2/3 rounded-md`}></div>
          </div>
          
          {/* 메타데이터 스켈레톤 */}
          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            {/* 읽기 시간 */}
            <div className="flex items-center gap-1">
              <div className={`${skeletonBase} w-4 h-4 rounded-full`}></div>
              <div className={`${skeletonBase} h-4 w-16`}></div>
            </div>
            
            {/* 조회수 */}
            <div className="flex items-center gap-2">
              <div className={`${skeletonBase} w-4 h-4 rounded-full`}></div>
              <div className={`${skeletonBase} h-4 w-12`}></div>
            </div>
            
            {/* 태그들 */}
            <div className="ml-auto flex items-center gap-1 flex-wrap">
              <div className={`${skeletonBase} h-5 w-12 rounded-md`}></div>
              <div className={`${skeletonBase} h-5 w-16 rounded-md`}></div>
              <div className={`${skeletonBase} h-5 w-14 rounded-md`}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// 태그 사이드바 스켈레톤 컴포넌트
function TagSidebarSkeleton({ className = "" }: { className?: string }) {
  return (
    <div className={`bg-white rounded-lg p-3 md:p-6 ${className}`}>
      <div className="mb-8">
        {/* 타이틀 스켈레톤 */}
        <div className={`${skeletonBase} h-5 w-12 mb-4 rounded-md`}></div>
        
        {/* 태그들 스켈레톤 */}
        <div className="flex flex-wrap gap-1.5">
          {[...Array(5)].map((_, index) => (
            <div key={index} className={`${skeletonBase} h-5 rounded-md w-72`}></div>
          ))}
        </div>
      </div>
    </div>
  );
}

// 메인 블로그 페이지 스켈레톤 컴포넌트
export default function BlogPageSkeleton() {
  return (
    <div className="flex flex-col lg:flex-row gap-8">
      {/* Mobile Sidebar - Top */}
      <div className="lg:hidden">
        <TagSidebarSkeleton />
      </div>

      {/* Main Content */}
      <div className="flex-1">
        <ul className="space-y-6">
          {[...Array(5)].map((_, index) => (
            <li key={index}>
              <BlogCardSkeleton />
            </li>
          ))}
        </ul>
      </div>

      {/* Desktop Sidebar - Right, Sticky */}
      <div className="hidden lg:block lg:w-80">
        <TagSidebarSkeleton className="sticky top-20" />
      </div>
    </div>
  );
} 